import React from "react";
import PropTypes from "prop-types";
import useStyles from "@hooks/useStyles";
import useStores from "@hooks/useStores";

import Box from "@material-ui/core/Box";
import Divider from "@material-ui/core/Divider";
import Avatar from "@material-ui/core/Avatar";
import Zoom from "@material-ui/core/Zoom";
//import ArrowForwardIcon from "@material-ui/icons/ArrowForward";
import CheckIcon from "@material-ui/icons/Check";
import { withStyles } from "@material-ui/core/styles";
import Tooltip from "@material-ui/core/Tooltip";

import ContentBadgeDialog from "./ContentBadgeDialog";
import LazyLoad from "@custom/LazyLoad";

const LightTooltip = withStyles((theme) => ({
	tooltip: {
		backgroundColor: theme.palette.common.white,
		color: "rgba(0, 0, 0, 0.87)",
		boxShadow: theme.shadows[3],
		maxWidth: 370,
	},
}))(Tooltip);

const ContentAuthor = () => {
	const classes = useStyles("Content");
	const { contentStore: store } = useStores();

	const [open, setOpen] = React.useState(false);

	const handleClickOpen = () => {
		setOpen(true);
	};

	const handleClose = () => {
		setOpen(false);
	};

	return (
		<React.Fragment>
			<Box
				mt={7}
				fontSize={14}
				display={"flex"}
				justifyContent={"space-between"}
				alignItems={{ sm: "center" }}
				flexDirection={{ xs: "column", sm: "row" }}
			>
				{store.authors.map((author, i) => (
					<Box display={"flex"} alignItems={"center"} key={`author-${i}`}>
						<LazyLoad>
							<Avatar
								style={{ width: 40, height: 40 }}
								alt={author.name}
								src={author.image ? author.image[0]?.secure_url : ""}
								imgProps={{
									loading: "lazy",
									decoding: "async",
									fetchpriority: "high",
								}}
							/>
						</LazyLoad>
						<Box ml={2} display={"flex"} flexDirection={"column"}>
							<Box mb={1}>
								<span className={classes.authorSub}>Written by </span>

								<Box display="inline-block">
									<LightTooltip
										interactive
										title={
											<Box display={"flex"} flexDirection={"column"} mt={1}>
												<Box display={"flex"} alignItems="center">
													<LazyLoad>
														<Avatar
															style={{ width: 64, height: 64 }}
															alt={author.name}
															src={
																author.image ? author.image[0]?.secure_url : ""
															}
															imgProps={{
																loading: "lazy",
																decoding: "async",
															}}
														/>
													</LazyLoad>
													<Box ml={4} mr={4}>
														<Box mb={1} className={classes.tooltipSub}>
															Written by
														</Box>
														<Box
															fontSize={16}
															fontWeight={700}
															lineHeight={1}
															mb={1}
														>
															{author.name}
														</Box>
														<div className={classes.tooltipSub}>
															{author.role}
														</div>
													</Box>
													{/* <Box ml="auto">
														<ArrowForwardIcon color="primary" />
													</Box> */}
												</Box>
												<Box pt={3} pb={3}>
													<Divider light />
												</Box>
												<Box mb={2} className={classes.tooltipSub}>
													{author[`bio${store.content.site.ucFirst()}`]}
												</Box>
											</Box>
										}
										TransitionComponent={Zoom}
										placement={"top"}
									>
										<div
											className={classes.authorName}
											onClick={handleClickOpen}
										>
											{author.name}
										</div>
									</LightTooltip>
								</Box>
								{/* <Box
									className={classes.authorName}
									component="a"
									href="/about/person"
									display={{ xs: "inline-block", sm: "none !important" }}
									fontWeight={600}
								>
									{author.name}
								</Box> */}
							</Box>
							<div className={classes.authorSub}>
								{!!store.publishedAt && (
									<React.Fragment>
										{/* {`Updated on `} */}
										<span>
											<time dateTime={store.publishedAt.standard}>
												{store.publishedAt.pretty}
											</time>
										</span>

										{/* <Box component={"span"} mx={2}>
									&bull;
								</Box> */}
									</React.Fragment>
								)}

								{/* <span>{`${store.readTimeMins} min read`}</span> */}
							</div>
						</Box>
					</Box>
				))}
				<Box display={"flex"} flexDirection={"column"} mt={{ xs: 4, sm: 0 }}>
					{store.editors.map((editor, i) => (
						<Box display={"flex"} alignItems={"center"} key={`editor-${i}`}>
							<Box
								display={"flex"}
								alignItems={"center"}
								justifyContent="center"
								width={{ xs: 40, sm: 30 }}
							>
								<CheckIcon color={"primary"} />
							</Box>
							<Box ml={2}>
								<span className={classes.authorSub}>Edited by </span>
								{/* <Box className={classes.authorName}>{editor.name}</Box> */}

								<LightTooltip
									interactive
									title={
										<Box display={"flex"} flexDirection={"column"} mt={1}>
											<Box display={"flex"} alignItems="center">
												<LazyLoad>
													<Avatar
														style={{ width: 64, height: 64 }}
														alt={editor.name}
														src={
															editor.image ? editor.image[0]?.secure_url : ""
														}
														imgProps={{
															loading: "lazy",
															decoding: "async",
														}}
													/>
												</LazyLoad>
												<Box ml={4} mr={4}>
													<Box mb={1} className={classes.tooltipSub}>
														Edited by
													</Box>
													<Box
														fontSize={16}
														fontWeight={700}
														lineHeight={1}
														mb={1}
													>
														{editor.name}
													</Box>
													<div className={classes.tooltipSub}>
														{editor.role}
													</div>
												</Box>
												{/* <Box ml="auto">
														<ArrowForwardIcon color="primary" />
													</Box> */}
											</Box>
											<Box pt={3} pb={3}>
												<Divider light />
											</Box>
											<Box mb={2} className={classes.tooltipSub}>
												{editor[`bio${store.content.site.ucFirst()}`]}
											</Box>
										</Box>
									}
									TransitionComponent={Zoom}
									placement={"top"}
								>
									<div className={classes.authorName} onClick={handleClickOpen}>
										{editor.name}
									</div>
								</LightTooltip>
							</Box>
						</Box>
					))}
					{store.reviewers.map((reviewer, i) => (
						<Box display={"flex"} alignItems={"center"} key={`reviewer-${i}`}>
							<Box
								display={"flex"}
								alignItems={"center"}
								justifyContent="center"
								width={{ xs: 40, sm: 30 }}
							>
								<CheckIcon color={"primary"} />
							</Box>
							<Box ml={2}>
								<span className={classes.authorSub}>Fact-checked by </span>

								<LightTooltip
									interactive
									title={
										<Box display={"flex"} flexDirection={"column"} mt={1}>
											<Box display={"flex"} alignItems="center">
												<LazyLoad>
													<Avatar
														style={{ width: 64, height: 64 }}
														alt={reviewer.name}
														src={
															reviewer.image ? reviewer.image[0].secure_url : ""
														}
														imgProps={{
															loading: "lazy",
															decoding: "async",
														}}
													/>
												</LazyLoad>
												<Box ml={4} mr={4}>
													<Box mb={1} className={classes.tooltipSub}>
														Fact-checked by
													</Box>
													<Box
														fontSize={16}
														fontWeight={700}
														lineHeight={1}
														mb={1}
													>
														{reviewer.name}
													</Box>
													<div className={classes.tooltipSub}>
														{reviewer.role}
													</div>
												</Box>
												{/* <Box ml="auto">
														<ArrowForwardIcon color="primary" />
													</Box> */}
											</Box>
											<Box pt={3} pb={3}>
												<Divider light />
											</Box>
											<Box mb={2} className={classes.tooltipSub}>
												{reviewer[`bio${store.content.site.ucFirst()}`]}
											</Box>
										</Box>
									}
									TransitionComponent={Zoom}
									placement={"top"}
								>
									<div className={classes.authorName} onClick={handleClickOpen}>
										{reviewer.name}
									</div>
								</LightTooltip>
							</Box>
						</Box>
					))}
				</Box>
			</Box>

			{open && (
				<ContentBadgeDialog close={handleClose} open={handleClickOpen} />
			)}
		</React.Fragment>
	);
};

ContentAuthor.propTypes = {};
export default ContentAuthor;
